export default {
  title: {
    id: 'litterature_title',
    defaultMessage: 'What else?',
  },
  subtitle: {
    id: 'litterature_subtitle',
    defaultMessage: '- Four questions people always ask:',
  },

  question1: {
    id: 'litterature_question1',
    defaultMessage:
      "“What's the difference between a used iPhone and a refurbished iPhone?“",
  },
  answer1: {
    id: 'litterature_answer1',
    defaultMessage:
      'In both cases, the two devices are pre-owned. The similarities end there. A {important1, html} has been tuned up and brought back to perfect working condition in a factory before being sold on Back Market (or somewhere else). So basically a refurbished phone has the double advantage of being a {important2, html} while also having a {important3, html} guarantee its {important4, html}.',
  },
  answer1ImportantText1: {
    id: 'litterature_answer1_important_text1',
    defaultMessage: 'refurbished iPhone',
  },
  answer1ImportantText2: {
    id: 'litterature_answer1_important_text2',
    defaultMessage: 'cheap smartphone',
  },
  answer1ImportantText3: {
    id: 'litterature_answer1_important_text3',
    defaultMessage: 'refurbisher guarante',
  },
  answer1ImportantText4: {
    id: 'litterature_answer1_important_text4',
    defaultMessage: 'excellent quality',
  },

  question2: {
    id: 'litterature_question2',
    defaultMessage:
      '“Does Back Market only sell refurbished tablets and smartphones?“',
  },
  answer2: {
    id: 'litterature_answer2',
    defaultMessage:
      'No. This is a pretty common misconception about Back Market that we want to clear up. A lot of people think that refurbished electronics are limited to {link1, html} and {link2, html} and {link3, html} when in fact {important1, html} (or almost everything) {important2, html} (from {link4, html} to {link5, html}, {link6, html}, {link7, html} and a whole lot more). So make sure to stick around and browse the website — you might find a great deal on something unexpected.',
  },
  answer2Link1: {
    id: 'litterature_answer2_link1',
    defaultMessage:
      'https://www.backmarket.com/en-us/l/smartphones/0744fd27-8605-465d-8691-3b6dffda5969',
  },
  answer2Link1Text: {
    id: 'litterature_answer2_link1_text',
    defaultMessage: 'phones',
  },
  answer2Link2: {
    id: 'litterature_answer2_link2',
    defaultMessage:
      'https://www.backmarket.com/en-us/l/tablets/076e3232-bda6-424b-81a4-9a6c9c08e8ee',
  },
  answer2Link2Text: {
    id: 'litterature_answer2_link2_text',
    defaultMessage: 'tablets',
  },
  answer2Link3: {
    id: 'litterature_answer2_link3',
    defaultMessage:
      'https://www.backmarket.com/en-us/l/computers-laptops/41f464b5-9356-48d3-86c3-a2bf52ced60e',
  },
  answer2Link3Text: {
    id: 'litterature_answer2_link3_text',
    defaultMessage: 'computers & laptops',
  },
  answer2Link4: {
    id: 'litterature_answer2_link4',
    defaultMessage:
      'https://www.backmarket.com/en-us/l/video-game-consoles/80395538-89ab-4cce-9fef-d8fbef431fb6',
  },
  answer2Link4Text: {
    id: 'litterature_answer2_link4_text',
    defaultMessage: 'consoles',
  },
  answer2Link5: {
    id: 'litterature_answer2_link5',
    defaultMessage:
      'https://www.backmarket.com/en-us/l/blender-mixers/5d3cdc6b-327e-4b8a-b7a6-193e2365c4d5',
  },
  answer2Link5Text: {
    id: 'litterature_answer2_link5_text',
    defaultMessage: 'blenders',
  },
  answer2Link6: {
    id: 'litterature_answer2_link6',
    defaultMessage:
      'https://www.backmarket.com/en-us/l/headphones-earphones/9159352b-4a5b-4348-aef0-2fa89f54ba13',
  },
  answer2Link6Text: {
    id: 'litterature_answer2_link6_text',
    defaultMessage: 'headphones',
  },
  answer2Link7: {
    id: 'litterature_answer2_link7',
    defaultMessage:
      'https://www.backmarket.com/en-us/l/watches/4ee50ebd-1eb4-4436-a797-80828ce28cc5',
  },
  answer2Link7Text: {
    id: 'litterature_answer2_link7_text',
    defaultMessage: 'smart watches',
  },
  answer2ImportantText1: {
    id: 'litterature_answer2_important_text1',
    defaultMessage: 'everything',
  },
  answer2ImportantText2: {
    id: 'litterature_answer2_important_text2',
    defaultMessage: 'can be refurbished',
  },

  question3: {
    id: 'litterature_question3',
    defaultMessage:
      "“How do I know that my refurbished tablet isn't going to conk out in 1 month?“",
  },
  answer3: {
    id: 'litterature_answer3',
    defaultMessage:
      "You have our good faith, but we know that's not enough. We've made our {link, html} available for you to see for yourself that you're in good hands. And in case of some unlikely glitch, our {important1, html} allow you to get a full refund, or to exchange your product for a minimum of {important2, html}.",
  },
  answer3LinkText: {
    id: 'litterature_answer3_link_text',
    defaultMessage: 'customer reviews',
  },
  answer3LinkTitle: {
    id: 'litterature_answer3_link_title',
    defaultMessage: 'Back Market customer reviews',
  },
  answer3ImportantText1: {
    id: 'litterature_answer3_important_text1',
    defaultMessage: 'warranties',
  },
  answer3ImportantText2: {
    id: 'litterature_answer3_important_text2',
    defaultMessage: '{warrantyDuration}-year',
  },

  question4: {
    id: 'litterature_question4',
    defaultMessage: "“Is Harry Potter's Nimbus 2000 refurbished?“",
  },
  answer4: {
    id: 'litterature_answer4',
    defaultMessage:
      "Well now. That's just too important a question to answer in a few lines. And that's why we've written a whole article about it in our {link, html}.",
  },
  answer4LinkText: {
    id: 'litterature_answer4_link_text',
    defaultMessage: 'fantastic blog',
  },
  answer4Link: {
    id: 'litterature_answer4_link',
    defaultMessage:
      'https://story.backmarket.com/was-harry-potters-nimbus-2000-a-refurbished-broom/',
  },
  answer4LinkTitle: {
    id: 'litterature_answer4_link_title',
    defaultMessage: 'refurbished Harry Potter’s Nimbus 2000',
  },

  faq: {
    id: 'litterature_faq',
    defaultMessage: 'see our faqs',
  },
  faqTitle: {
    id: 'litterature_faq_title',
    defaultMessage: 'Backmarket FAQ',
  },
}
